import { RefreshCw } from "lucide-react";

import { PageHeader, btn, Loader } from "@/components/Page";
import { useMiningDashboard } from "@/hooks/useMiningDashboard";
import { MiningTabs } from "@/components/mining/MiningTabs";
import { MiningSummaryPanel } from "@/components/mining/MiningSummaryPanel";
import { MiningResourcesPanel } from "@/components/mining/MiningResourcesPanel";
import { MiningDiscoveryPanel } from "@/components/mining/MiningDiscoveryPanel";
import { MiningEquipmentLink } from "@/components/mining/MiningEquipmentLink";

export default function MiningJournal() {
  const { data, loading, loadMining, liveSmithing } = useMiningDashboard();

  if (loading && !data) return <Loader label="Loading Expedition Journal..." />;

  return (
    <div data-testid="mining-journal-page" className="space-y-6">
      <PageHeader
        title="Expedition Journal"
        subtitle="Review your discovery archive and track the rarest things your crews have unearthed."
        action={
          <button data-testid="mining-journal-refresh-button" type="button" onClick={() => loadMining()} className={btn("ghost") + " flex items-center gap-2"}>
            <RefreshCw size={15} /> Refresh
          </button>
        }
      />

      <MiningEquipmentLink />

      <MiningTabs claimableCount={data?.discoveries?.claimable_count || 0} />



      <div className="grid xl:grid-cols-[1fr_1fr] gap-6">
        <MiningSummaryPanel profile={data?.profile} smithing={liveSmithing || data?.smithing} />
        <MiningResourcesPanel profile={data?.profile} showHistory={false} />
      </div>

      <MiningDiscoveryPanel discoveries={data?.discoveries} pageSize={6} />
    </div>
  );
}